/**
 * Wrapper for QuickCreateMenu that launches the inbound stock movement wizard.
 */
import { StockMovementWizard } from '../../modules/inventory/components/StockMovementWizard';

interface Props {
  open: boolean;
  onClose: () => void;
}

export function QuickCreateStockReceiptForm({ open, onClose }: Props) {
  return <StockMovementWizard open={open} onClose={onClose} direction="inbound" />;
}
